webpackJsonp([96],{

/***/ 2330:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoginOrRegister_vue__ = __webpack_require__(2759);
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d75076c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoginOrRegister_vue__ = __webpack_require__(2935);
var disposed = false
function injectStyle (ssrContext) {
  if (disposed) return
  __webpack_require__(2933)
}
var normalizeComponent = __webpack_require__(6)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2d75076c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoginOrRegister_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d75076c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoginOrRegister_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/components/views/account/LoginOrRegister.vue"

/* hot reload */
if (false) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-2d75076c", Component.options)
  } else {
    hotAPI.reload("data-v-2d75076c", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 2759:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__ = __webpack_require__(17);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_forms_LoginForm__ = __webpack_require__(1247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router_index__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__constants_platformNames__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mixins_account_mixin__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_base_BaseDialog__ = __webpack_require__(109);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Login',
  mixins: [__WEBPACK_IMPORTED_MODULE_4__mixins_account_mixin__["a" /* default */]],
  components: {
    BForm: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["m" /* BForm */],
    BAlert: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["a" /* BAlert */],
    BFormGroup: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["r" /* BFormGroup */],
    BFormInput: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["s" /* BFormInput */],
    BFormInvalidFeedback: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["t" /* BFormInvalidFeedback */],
    BButton: __WEBPACK_IMPORTED_MODULE_0_bootstrap_vue__["d" /* BButton */],
    LoginForm: __WEBPACK_IMPORTED_MODULE_1__components_forms_LoginForm__["default"],
    BaseDialog: __WEBPACK_IMPORTED_MODULE_5__components_base_BaseDialog__["default"]
  },
  data: function data() {
    return {
      USER_TYPES: null,
      dialogOpenlegalLaywerVisible: false,
      inOpenlegal: __WEBPACK_IMPORTED_MODULE_3__constants_platformNames__["j" /* inOpenlegal */],
      inOpensalud360: __WEBPACK_IMPORTED_MODULE_3__constants_platformNames__["k" /* inOpensalud360 */]
    };
  },

  methods: {
    registerUser: function registerUser(userType) {
      var returnUrl = __WEBPACK_IMPORTED_MODULE_2__router_index__["a" /* default */].currentRoute.query.returnUrl || __WEBPACK_IMPORTED_MODULE_2__router_index__["a" /* default */].currentRoute.query.ReturnUrl;
      // Regex to capture string like HomePaciente, HomeProfesional, HomeCentro in return url
      if (returnUrl) {
        var match = /home(paciente|profesional|centro)+/i.exec(returnUrl);
        if (match && match[1] && match[1].toLowerCase() !== userType) {
          returnUrl = null;
        }
      }
      this.$router.push('/registro-' + userType + (returnUrl ? '?returnUrl=' + encodeURIComponent(returnUrl) : ''));
    },
    registerProfessional: function registerProfessional() {
      if (this.inOpenlegal()) {
        this.dialogOpenlegalLaywerVisible = true;
        return;
      }
      return this.registerUser(this.USER_TYPES.PROFESSIONAL);
    },
    registerPatient: function registerPatient() {
      return this.registerUser(this.USER_TYPES.PATIENT);
    },
    registerCenter: function registerCenter() {
      return this.registerUser(this.USER_TYPES.CENTER);
    }
  },
  created: function created() {
    /* this.redirectIfAuthenticated() */
    this.USER_TYPES = {
      PATIENT: this.inOpenlegal() ? 'cliente' : 'paciente',
      PROFESSIONAL: this.inOpenlegal() ? 'abogado' : 'profesional',
      CENTER: this.inOpenlegal() ? 'bufete' : 'centro'
    };
  },

  computed: {
    showProfessionalButton: function showProfessionalButton() {
      return !Object(__WEBPACK_IMPORTED_MODULE_3__constants_platformNames__["k" /* inOpensalud360 */])();
    },
    showCenterButton: function showCenterButton() {
      return !this.inOpenlegal() && !Object(__WEBPACK_IMPORTED_MODULE_3__constants_platformNames__["k" /* inOpensalud360 */])();
    },
    patientBtnText: function patientBtnText() {
      return this.inOpenlegal() ? this.$t('login.iam-client') : Object(__WEBPACK_IMPORTED_MODULE_3__constants_platformNames__["k" /* inOpensalud360 */])() ? this.$t('signup-title') : this.$t('login.iam-patient');
    },
    cardHeight: function cardHeight() {
      return !this.$uiHelpers.isMobile ? this.inOpenlegal() ? '540px' : '457px' : 'auto';
    }
  }
});

/***/ }),

/***/ 2933:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(2934);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(9)("b68499f4", content, false, {});
// Hot Module Replacement
if(false) {
 // When the styles change, update the <style> tags
 if(!content.locals) {
   module.hot.accept("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-2d75076c\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./LoginOrRegister.vue", function() {
     var newContent = require("!!../../../../node_modules/css-loader/index.js?{\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/style-compiler/index.js?{\"vue\":true,\"id\":\"data-v-2d75076c\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/sass-loader/dist/cjs.js?{\"data\":\"@import \\\"static-appopensalud/css/scss/shared.scss\\\";\",\"sourceMap\":false}!../../../../node_modules/vue-loader/lib/selector.js?type=styles&index=0!./LoginOrRegister.vue");
     if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
     update(newContent);
   });
 }
 // When the module is disposed, remove the <style> tags
 module.hot.dispose(function() { update(); });
}

/***/ }),

/***/ 2934:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(8)(false);
// imports


// module
exports.push([module.i, "\n.overline-typescale[data-v-2d75076c]{font-size:12px;letter-spacing:1.25px;font-weight:lighter;text-transform:uppercase\n}\n.slide-down-enter-active[data-v-2d75076c],.slide-down-leave-active[data-v-2d75076c]{-webkit-transition:all 0.5s ease;transition:all 0.5s ease\n}\n.slide-down-enter[data-v-2d75076c],.slide-down-leave-to[data-v-2d75076c]{-webkit-transform:translateY(-100%);transform:translateY(-100%);opacity:0\n}\n.slide-fade-left-enter-active[data-v-2d75076c],.slide-fade-left-leave-active[data-v-2d75076c]{-webkit-transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:opacity 0.3s ease, -webkit-transform 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease;transition:transform 0.3s ease, opacity 0.3s ease, -webkit-transform 0.3s ease\n}\n.slide-fade-left-enter[data-v-2d75076c],.slide-fade-left-leave-to[data-v-2d75076c]{-webkit-transform:translateX(100%);transform:translateX(100%);opacity:0\n}\n.fade-enter-active[data-v-2d75076c]{-webkit-transition:opacity 0.3s ease;transition:opacity 0.3s ease\n}\n.fade-enter[data-v-2d75076c],.fade-leave-to[data-v-2d75076c]{opacity:0\n}\n@media only screen and (min-width: 2000px){\n.card-ctn[data-v-2d75076c]{padding:2rem 6rem !important\n}\n}\n@media only screen and (min-width: 1024px){\n.card-ctn[data-v-2d75076c]{padding:2rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.card-ctn[data-v-2d75076c]{padding:1rem 0rem\n}\n}\n@media only screen and (max-width: 575px){\n.card-ctn[data-v-2d75076c]{padding:1rem 0rem\n}\n}\n@media only screen and (max-width: 575px){\n.neu-cards-slider[data-v-2d75076c]{padding:0 !important\n}\n.neu-cards-slider .row [class*=\"col-\"][data-v-2d75076c]{margin-left:0 !important\n}\n}\n[data-v-2d75076c] .form-group{margin-bottom:1.5rem !important;margin-top:1rem !important\n}\n.neu-cards-slider[data-v-2d75076c]{font-size:14px !important;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center\n}\n@media only screen and (max-width: 575px){\n.neu-cards-slider[data-v-2d75076c]{padding:1rem\n}\n}\n.neu-cards-slider[data-v-2d75076c]:not(.black){background-repeat:no-repeat;background-size:cover;background-position-y:center\n}\n@media only screen and (min-width: 1024px){\n.neu-cards-slider .btn[data-v-2d75076c]{margin-top:3%\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.neu-cards-slider .btn[data-v-2d75076c]{margin-bottom:10%\n}\n}\n@media only screen and (max-width: 575px){\n.neu-cards-slider .btn[data-v-2d75076c]{margin-bottom:10%\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.neu-cards-slider .row[data-v-2d75076c]{display:contents;overflow-x:hidden;overflow-y:hidden;white-space:nowrap\n}\n.neu-cards-slider .row [class*=\"col-\"][data-v-2d75076c]{display:inline-block;width:100%\n}\n}\n@media only screen and (max-width: 575px){\n.neu-cards-slider .row[data-v-2d75076c]{display:contents;overflow-x:hidden;overflow-y:hidden;white-space:nowrap\n}\n.neu-cards-slider .row [class*=\"col-\"][data-v-2d75076c]{display:inline-block;width:100%\n}\n}\n@media only screen and (max-width: 575px) and (max-width: 320px){\n.neu-cards-slider .row [class*=\"col-\"][data-v-2d75076c]{margin-right:50%\n}\n}\n@media only screen and (max-width: 575px) and (min-width: 321px) and (max-width: 425px){\n.neu-cards-slider .row [class*=\"col-\"][data-v-2d75076c]{margin-left:2%\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.neu-cards-slider .row[data-v-2d75076c]{margin-bottom:2rem;-webkit-margin-after:5rem;margin-block-end:5rem\n}\n.neu-cards-slider .row[data-v-2d75076c]::-webkit-scrollbar{height:3px\n}\n.neu-cards-slider .row[data-v-2d75076c]::-webkit-scrollbar-track{background-color:#8A8A8A;border-radius:100px\n}\n.neu-cards-slider .row[data-v-2d75076c]::-webkit-scrollbar-thumb{background-color:#1D1D1E;border-radius:100px\n}\n.neu-cards-slider .row span[data-v-2d75076c]{white-space:normal\n}\n}\n@media only screen and (max-width: 575px){\n.neu-cards-slider .row[data-v-2d75076c]{margin-bottom:2rem;-webkit-margin-after:5rem;margin-block-end:5rem\n}\n.neu-cards-slider .row[data-v-2d75076c]::-webkit-scrollbar{height:3px\n}\n.neu-cards-slider .row[data-v-2d75076c]::-webkit-scrollbar-track{background-color:#8A8A8A;border-radius:100px\n}\n.neu-cards-slider .row[data-v-2d75076c]::-webkit-scrollbar-thumb{background-color:#1D1D1E;border-radius:100px\n}\n.neu-cards-slider .row span[data-v-2d75076c]{white-space:normal\n}\n}\n.neu-cards-slider .card-ctn2-login[data-v-2d75076c]{display:-webkit-box;display:-ms-flexbox;display:flex\n}\n@media only screen and (min-width: 1024px){\n.neu-cards-slider .card-ctn2-login[data-v-2d75076c]{padding:5rem 3rem 11rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.neu-cards-slider .card-ctn2-login[data-v-2d75076c]{padding:5rem 3rem 11rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.neu-cards-slider .card-ctn2-login[data-v-2d75076c]{padding:5rem\n}\n}\n@media only screen and (max-width: 575px){\n.neu-cards-slider .card-ctn2-login[data-v-2d75076c]{padding-bottom:2rem\n}\n}\n@media only screen and (max-width: 575px){\n.neu-cards-slider .card-ctn2-login .btn-mobile[data-v-2d75076c]{margin-bottom:1rem !important\n}\n}\n.neu-cards-slider .card-ctn2-login .neu-card-price[data-v-2d75076c]{width:20rem;-webkit-transition-duration:9999999s;transition-duration:9999999s;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center\n}\n.neu-cards-slider .card-ctn2-login .neu-card-price[data-v-2d75076c]:hover{-webkit-transition-duration:999999999s;transition-duration:999999999s\n}\n@media only screen and (min-width: 1024px){\n.neu-cards-slider .card-ctn2-login .neu-card-price[data-v-2d75076c]:hover{padding:5rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.neu-cards-slider .card-ctn2-login .neu-card-price[data-v-2d75076c]:hover{padding:2rem 5rem\n}\n}\n@media only screen and (min-width: 1024px){\n.neu-cards-slider .card-ctn2-login .neu-card-price[data-v-2d75076c]{display:-webkit-box;display:-ms-flexbox;display:flex;padding:5rem;height:470px;width:320px\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.neu-cards-slider .card-ctn2-login .neu-card-price[data-v-2d75076c]{display:-webkit-box;display:-ms-flexbox;display:flex;padding:3rem 5rem;height:400px;width:320px\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.neu-cards-slider .card-ctn2-login .neu-card-price[data-v-2d75076c]{display:table-cell;padding:7rem;width:100%;max-width:none\n}\n.neu-cards-slider .card-ctn2-login .neu-card-price span[data-v-2d75076c]{margin:auto\n}\n}\n@media only screen and (max-width: 575px){\n.neu-cards-slider .card-ctn2-login .neu-card-price[data-v-2d75076c]{display:block;padding:5rem 3rem;margin-bottom:3rem;min-height:280px\n}\n}\n.neu-cards-slider .card-ctn[data-v-2d75076c]{display:-webkit-box;display:-ms-flexbox;display:flex\n}\n@media only screen and (min-width: 1024px){\n.neu-cards-slider .card-ctn[data-v-2d75076c]{padding:0 7rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.neu-cards-slider .card-ctn[data-v-2d75076c]{padding:0 2rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.neu-cards-slider .card-ctn[data-v-2d75076c]{padding:0\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.neu-cards-slider .card-ctn[data-v-2d75076c]{margin-right:5rem;padding-right:4rem;padding-left:4rem;padding-top:4rem;padding-bottom:2rem\n}\n}\n@media only screen and (max-width: 575px){\n.neu-cards-slider .card-ctn[data-v-2d75076c]{margin-right:5rem;padding-right:4rem;padding-left:4rem;padding-top:4rem;padding-bottom:2rem\n}\n}\n.neu-cards-slider .card-ctn .neu-card-price[data-v-2d75076c]{display:-webkit-box;display:-ms-flexbox;display:flex\n}\n@media only screen and (min-width: 1024px){\n.neu-cards-slider .card-ctn .neu-card-price[data-v-2d75076c]{padding:5rem;min-height:400px;max-width:350px\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.neu-cards-slider .card-ctn .neu-card-price[data-v-2d75076c]{padding:2rem 5rem;min-height:300px;max-width:250px\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.neu-cards-slider .card-ctn .neu-card-price[data-v-2d75076c]{padding:7rem;width:100%;max-width:250px\n}\n.neu-cards-slider .card-ctn .neu-card-price span[data-v-2d75076c]{margin:auto\n}\n}\n@media only screen and (max-width: 575px){\n.neu-cards-slider .card-ctn .neu-card-price[data-v-2d75076c]{padding:5rem 3rem;margin-bottom:3rem;min-height:280px\n}\n}\n.neu-cards-slider .card-ctn .neu-card[data-v-2d75076c]{display:-webkit-box;display:-ms-flexbox;display:flex\n}\n@media only screen and (min-width: 1024px){\n.neu-cards-slider .card-ctn .neu-card[data-v-2d75076c]{padding:5rem;min-height:400px;max-width:350px\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.neu-cards-slider .card-ctn .neu-card[data-v-2d75076c]{padding:2rem 5rem;min-height:300px;max-width:250px\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.neu-cards-slider .card-ctn .neu-card[data-v-2d75076c]{padding:7rem;width:100%;max-width:250px\n}\n.neu-cards-slider .card-ctn .neu-card span[data-v-2d75076c]{margin:auto\n}\n}\n@media only screen and (max-width: 575px){\n.neu-cards-slider .card-ctn .neu-card[data-v-2d75076c]{padding:5rem 3rem;margin-bottom:3rem;min-height:280px\n}\n}\n.neu-cards-slider .card-ctn .neu-card-rates[data-v-2d75076c]{display:-webkit-box;display:-ms-flexbox;display:flex\n}\n@media only screen and (min-width: 1024px){\n.neu-cards-slider .card-ctn .neu-card-rates[data-v-2d75076c]{padding:5rem;min-height:500px;max-width:220px\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.neu-cards-slider .card-ctn .neu-card-rates[data-v-2d75076c]{padding:2rem 5rem;min-height:300px;max-width:250px\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.neu-cards-slider .card-ctn .neu-card-rates[data-v-2d75076c]{padding:7rem;width:100%;max-width:none\n}\n.neu-cards-slider .card-ctn .neu-card-rates span[data-v-2d75076c]{margin:auto\n}\n}\n@media only screen and (max-width: 575px){\n.neu-cards-slider .card-ctn .neu-card-rates[data-v-2d75076c]{padding:5rem 3rem;margin-bottom:3rem;min-height:280px\n}\n}\n.card-login[data-v-2d75076c]{width:100%;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;background-color:#eee;border-radius:23px !important;-webkit-box-shadow:-10px -10px 35px #fff,10px 10px 35px rgba(13,39,80,0.160784);box-shadow:-10px -10px 35px #fff,10px 10px 35px rgba(13,39,80,0.160784);border:0px !important;-webkit-box-sizing:border-box;box-sizing:border-box;border-radius:10px;text-align:center\n}\n.card-login h3[data-v-2d75076c]{color:black\n}\n@media only screen and (min-width: 1024px){\n.card-login[data-v-2d75076c]{padding:4rem 6rem\n}\n}\n@media only screen and (min-width: 0px) and (max-width: 1023px) and (orientation: landscape){\n.card-login[data-v-2d75076c]{padding:1rem 3rem\n}\n}\n@media only screen and (min-width: 576px) and (max-width: 1023px) and (orientation: portrait), only screen and (min-device-width: 1024px) and (max-device-height: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: portrait){\n.card-login[data-v-2d75076c]{padding:3rem 6rem\n}\n}\n@media only screen and (max-width: 575px){\n.card-login[data-v-2d75076c]{padding:2.5rem 1.5rem\n}\n.card-login h3[data-v-2d75076c]{font-size:1.3rem\n}\n}\n.card-login .card-ctn2[data-v-2d75076c]{display:-webkit-box;display:-ms-flexbox;display:flex\n}\n", ""]);

// exports


/***/ }),

/***/ 2935:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function() {
  var this$1 = this
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    [
      _c("base-dialog", {
        attrs: {
          okFn: function() {
            _vm.registerUser(this$1.USER_TYPES.PROFESSIONAL)
          },
          cancelFn: function() {
            _vm.dialogOpenlegalLaywerVisible = false
          },
          content: _vm.$t("login.dialog-lawyer")
        },
        model: {
          value: _vm.dialogOpenlegalLaywerVisible,
          callback: function($$v) {
            _vm.dialogOpenlegalLaywerVisible = $$v
          },
          expression: "dialogOpenlegalLaywerVisible"
        }
      }),
      _vm._v(" "),
      _c("b-col", { staticClass: "card-ctn", attrs: { cols: "12", xl: "6" } }, [
        _c(
          "div",
          {
            staticClass: "card-login",
            style: { "min-height": _vm.cardHeight }
          },
          [
            _c(
              "div",
              { staticClass: "my-auto" },
              [
                _c("login-form", {
                  attrs: { title: _vm.$t("login.already-signed-in") }
                })
              ],
              1
            )
          ]
        )
      ]),
      _vm._v(" "),
      _c("b-col", { staticClass: "card-ctn", attrs: { cols: "12", xl: "6" } }, [
        _c(
          "div",
          {
            staticClass: "card-login",
            style: { "min-height": _vm.cardHeight }
          },
          [
            _c(
              "div",
              { staticClass: "my-auto" },
              [
                _c("div", [
                  _c("h3", [
                    _vm._v(
                      "\n\t\t\t\t\t\t" +
                        _vm._s(_vm.$t("login.new-user")) +
                        "\n\t\t\t\t\t"
                    )
                  ]),
                  _vm._v(" "),
                  !_vm.inOpensalud360()
                    ? _c("p", { staticStyle: { "white-space": "initial" } }, [
                        _vm._v(
                          "\n\t\t\t\t\t\t" +
                            _vm._s(_vm.$t("login.register-now")) +
                            "\n\t\t\t\t\t"
                        )
                      ])
                    : _vm._e()
                ]),
                _vm._v(" "),
                _vm.showProfessionalButton
                  ? _c(
                      "base-button",
                      {
                        staticClass: "mt-4 d-block w-100 btn-mobile",
                        attrs: { variant: "primary" },
                        on: { click: _vm.registerProfessional }
                      },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t" +
                            _vm._s(
                              _vm.inOpenlegal()
                                ? _vm.$t("login.iam-lawyer")
                                : _vm.$t("login.iam-professional")
                            ) +
                            "\n\t\t\t\t"
                        )
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "base-button",
                  {
                    staticClass: "w-100 btn-mobile mt-4 d-block",
                    attrs: { variant: "primary" },
                    on: { click: _vm.registerPatient }
                  },
                  [
                    _vm._v(
                      "\n\t\t\t\t\t" + _vm._s(_vm.patientBtnText) + "\n\t\t\t\t"
                    )
                  ]
                ),
                _vm._v(" "),
                _vm.showCenterButton
                  ? _c(
                      "base-button",
                      {
                        staticClass: "w-100 btn-mobile mt-4 d-block",
                        attrs: { variant: "primary" },
                        on: { click: _vm.registerCenter }
                      },
                      [
                        _vm._v(
                          "\n\t\t\t\t\t" +
                            _vm._s(
                              _vm.inOpenlegal()
                                ? _vm.$t("login.iam-lawfirm")
                                : _vm.$t("login.iam-centre")
                            ) +
                            "\n\t\t\t\t"
                        )
                      ]
                    )
                  : _vm._e()
              ],
              1
            )
          ]
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);
if (false) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2d75076c", esExports)
  }
}

/***/ })

});


// WEBPACK FOOTER //
// static-appopensalud/js/96.c5326766fc84cc9454ee.js